import { render, staticRenderFns } from "./graficas.vue?vue&type=template&id=5045e6a2&"
import script from "./graficas.vue?vue&type=script&lang=js&"
export * from "./graficas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports